import React from 'react';
import { useIntl } from '@kyruus/intl';
import type { UseCrmConnectorReturnType } from '@kyruus/crm-connector-widget';
import { InvalidPatientDataAlert } from './InvalidPatientDataAlert';
import { AlertsContainer } from './styles';
import { messages } from '../useCrmConnector/messages';

interface InvalidPatientDataAlertsProps {
  crmConnector: UseCrmConnectorReturnType;
  isBookingEnabled?: boolean;
  isReferralEnabled?: boolean;
}
export const InvalidPatientDataAlerts = ({
  crmConnector,
  isBookingEnabled = false,
  isReferralEnabled = false
}: InvalidPatientDataAlertsProps) => {
  const intl = useIntl();
  return (
    <AlertsContainer>
      {isBookingEnabled &&
        crmConnector.hasPatientValidationErrorsForBooking() && (
          <InvalidPatientDataAlert
            title={intl.formatMessage(messages.invalidPatientDataBooking)}
            invalidFields={
              crmConnector.state.context?.validationErrors?.booking?.data ?? []
            }
          />
        )}
      {isReferralEnabled &&
        crmConnector.hasPatientValidationErrorsForReferral() && (
          <InvalidPatientDataAlert
            title={intl.formatMessage(messages.invalidPatientDataReferral)}
            invalidFields={
              crmConnector.state.context?.validationErrors?.referral?.data ?? []
            }
          />
        )}
    </AlertsContainer>
  );
};
